import { Box } from "@mui/material"
import { getContentCellSx, sectionHeadingCellSx } from "./pdf-task-comparison-helpers"
import { TaskRowHeader } from "./task-row-header"
import { HeaderPanel } from "./header-panel"
import { PdfAuthorNote } from "./pdf-author-note"
import { If } from "lib/@components/switch"
import { sanitizePdfHtml } from "./pdf-formatters"

export function TaskHeaderRows({ item, showUnchangedNote }) {
    const safeAuthorNote = buildSanitizedNote(item.note)
    const hasAuthorNote = Boolean(safeAuthorNote?.content)

    return (
        <>
            <Box component="tr">
                <Box component="td" colSpan={2} sx={sectionHeadingCellSx}>
                    <TaskRowHeader label={item.label} status={item.status} />
                </Box>
            </Box>
            <Box component="tr">
                <Box component="td" sx={getContentCellSx("left", item.status !== "unchanged")}>
                    <HeaderPanel
                        task={item.originalTask}
                        status={item.status}
                        side={"left"}
                        showUnchangedNote={showUnchangedNote}
                    />
                </Box>
                <Box component="td" sx={getContentCellSx("right", item.status !== "unchanged")}>
                    <HeaderPanel
                        task={item.draftTask}
                        status={item.status}
                        side={"right"}
                        showUnchangedNote={showUnchangedNote}
                    />
                </Box>
            </Box>
            <If value={hasAuthorNote}>
                <Box component="tr" sx={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
                    <Box
                        component="td"
                        colSpan={2}
                        sx={{ p: 0, pt: "10px", pageBreakInside: "avoid", breakInside: "avoid" }}
                    >
                        <PdfAuthorNote note={safeAuthorNote} />
                    </Box>
                </Box>
            </If>
            <Box component="tr">
                <Box component="td" colSpan={2} sx={{ p: 0, pb: "18px" }} />
            </Box>
        </>
    )
}

function buildSanitizedNote(note) {
    if (!note) return note

    return {
        ...note,
        content: sanitizePdfHtml(note.content),
    }
}
